import { auth as firebaseAuth } from "services/firebase";
import {
	RecaptchaVerifier,
	signInWithPhoneNumber,
	signInWithCustomToken,
	signOut,
	PhoneAuthProvider,
	signInWithCredential,
	getAuth,
} from "firebase/auth";

import apiTwilio from "./apiTwilio";
import api from "./api";

// Removed firebase compat imports to avoid mixing modular and namespaced APIs
const auth = getAuth();

export const sendMsgWavy = (celphone) => {
	return apiTwilio.apiTwilio.post("user/auth/wavy", {
		phone: celphone,
	});
};

export const sendMessageWavy = (celphone, codeWhatsApp) => {
	return apiTwilio.apiTwilio.post("user/auth/wavy/verify", {
		phone: celphone,
		code: codeWhatsApp,
	});
};

export const verifyAuthCode = (codeWhatsApp) => {
	return apiTwilio.apiTwilio.post("auth_link/verify", {
		code: codeWhatsApp,
	});
};

export const sendSMSCodeTwilio = (celphone, codeTwilio) => {
	return apiTwilio.apiTwilio.post('user/auth/verify', {
		phone: celphone,
		code: codeTwilio,
	});
};

export const sendTokenFirebase = (auth, token) => {
	return signInWithCustomToken(auth, token);
};

export const logoutUser = (auth) => {
	return signOut(auth);
};

export const fetchStoreVersion = () => {
	return api.get("store");
};

export const userAuthAi = (celphone) => {
	return apiTwilio.apiTwilio.post("user/auth/ai", {
		phone: celphone,
	});
};

export const sendNumber = async (number) => {
	if (!number || !number.startsWith("+")) {
		return Promise.reject(new Error("Invalid phone format. Expected E.164 with leading '+'"));
	}

	if (!number.startsWith("+55") && !number.startsWith("+351")) {
		auth.languageCode = "en";
	}

	if (!document.getElementById("recaptcha-container")) {
		throw new Error("Elemento #recaptcha-container não encontrado no DOM");
	}
	
	if (window.recaptchaVerifier && window.recaptchaVerifier.destroyed) {
		window.recaptchaVerifier.clear();
		window.recaptchaVerifier = null;
	}

	if (!window.recaptchaVerifier) {
		window.recaptchaVerifier = new RecaptchaVerifier(
			"recaptcha-container",
			{
				size: "invisible",
				callback: () => {},
				"expired-callback": () => {
					if (window.recaptchaVerifier) {
						window.recaptchaVerifier.clear();
						window.recaptchaVerifier = null;
					}
				},
			},
			auth
		);
	}

	const appVerifier = window.recaptchaVerifier;
	return signInWithPhoneNumber(auth, number, appVerifier);
};

export const getCredential = (verificationId, code) => {
	return PhoneAuthProvider.credential(verificationId, code);
};

export const authenticateUser = async (credential) => {
	return await signInWithCredential(firebaseAuth, credential);
};

export const verifyCode = (verificationId, code) => {
	const credential = getCredential(verificationId, code);
	return authenticateUser(credential);
};
